(() => {
  'use strict';
  const dialog = document.querySelector('[data-ab9-dialog]');
  if (!dialog) return;
  const root = dialog.dataset.root || '/';
  const url = path => root + path.replace(/^\//, '');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:dialog.dataset.currency || 'AUD'}).format(value / 100);
  const $ = selector => dialog.querySelector(selector);
  let map = {}, product = null, family = [], selected = [], variant = null, opener = null, loading = 0;
  const cache = new Map();
  const dataReady = fetch(dialog.dataset.colourMap).then(r => r.ok ? r.json() : {}).then(data => { map = data; enhanceCards(); }).catch(() => {});
  function element(tag, props = {}, text) { const el=document.createElement(tag); Object.assign(el, props); if(text !== undefined) el.textContent=text; return el; }
  function cardData(card) { try { return JSON.parse(card.querySelector('[data-ab9-product-json]').getAttribute('data-ab9-product-json')); } catch(e) { return null; } }
  async function loadProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const response=await fetch(url('products/' + encodeURIComponent(handle) + '.js'), {credentials:'same-origin'});
    const data=await response.json(); if(!response.ok) throw new Error(data.description || 'Product unavailable. Please view full details.');
    cache.set(handle,data); return data;
  }
  function images(p) { return (p.images || []).map(x => typeof x === 'string' ? x : x.src).filter(Boolean); }
  function options(p) { return (p.options || []).map((o,i) => typeof o === 'string' ? {name:o,values:[...new Set(p.variants.map(v=>v.options[i]))]} : o); }
  function setStatus(message) { $('[data-ab9-status]').textContent=message; }
  function findVariant() { variant=product.variants.find(v=>v.options.every((o,i)=>o===selected[i])); return variant; }
  function updatePurchase() {
    findVariant(); const add=$('[data-ab9-add]');
    add.disabled=!variant || !variant.available;
    add.firstChild.textContent=variant ? (variant.available ? 'Add to cart ' : 'Sold out ') : 'Select size ';
    $('[data-ab9-price]').textContent=money(variant ? variant.price : product.price);
  }
  function renderOptions() {
    const host=$('[data-ab9-options]'); host.replaceChildren();
    options(product).forEach((o,i)=> {
      if(o.name === 'Title' && o.values.length === 1 && o.values[0] === 'Default Title') { selected[i]=o.values[0]; return; }
      const group=element('div',{className:'ab9-option-group'});
      if(!/size/i.test(o.name)) group.append(element('span',{},o.name));
      const values=element('div',{className:'ab9-option-values'}); values.setAttribute('role','group'); values.setAttribute('aria-label',o.name);
      o.values.forEach(value=> {
        const button=element('button',{type:'button'},value);
        button.setAttribute('aria-pressed',selected[i]===value ? 'true':'false');
        button.disabled=!product.variants.some(v=>v.available && v.options[i]===value && v.options.every((val,j)=>j===i || !selected[j] || selected[j]===val));
        button.addEventListener('click',()=>{selected[i]=value; renderOptions(); updatePurchase();}); values.append(button);
      }); group.append(values); host.append(group);
    }); updatePurchase();
  }
  function renderColours() {
    const host=$('[data-ab9-colours]');host.replaceChildren();
    const siblings=map[product.handle] || family;
    const current=siblings.find(x=>x.handle===product.handle);
    $('[data-ab9-colour-name]').textContent=current?.colour || (product.title.includes('|') ? product.title.split('|').pop().trim() : '');
    siblings.forEach(x=> {
      const button=element('button',{type:'button',title:x.colour});button.setAttribute('aria-label',x.colour);button.setAttribute('aria-pressed',x.handle===product.handle ? 'true':'false');
      const dot=element('span',{className:'ab9-colour-dot'});dot.style.background=x.hex;button.append(dot,element('small',{},x.colour));
      button.addEventListener('click',async()=>{ if(x.handle===product.handle)return; const seq=++loading;setStatus('Loading colour…'); $('[data-ab9-add]').disabled=true;
        try{const p=await loadProduct(x.handle);if(seq!==loading)return;renderProduct(p);setStatus('');}catch(e){setStatus(e.message);updatePurchase();}
      });host.append(button);
    });
    host.hidden=siblings.length===0;
  }
  function renderProduct(p) {
    product=p;selected=Array(options(p).length).fill(null);variant=null;
    options(p).forEach((o,i)=>{if(o.values.length===1)selected[i]=o.values[0];});
    $('[data-ab9-title]').textContent=p.title.split('|')[0].trim();
    $('[data-ab9-details]').href=url('products/'+p.handle);
    const gallery=$('[data-ab9-gallery]');gallery.replaceChildren();
    images(p).slice(0,6).forEach(src=>gallery.append(element('img',{src,alt:p.title,loading:'eager'})));
    renderColours();renderOptions();setStatus('');
  }
  function close() { dialog.close(); document.documentElement.classList.remove('ab9-modal-open'); if(opener?.isConnected)opener.focus(); }
  async function open(button) {
    opener=button; const handle=button.dataset.ab9Open;
    const local=cardData(button.closest('.product-block'));
    if(local)cache.set(handle,local);
    await dataReady; family=map[handle] || [];renderProduct(local || await loadProduct(handle));
    dialog.showModal();document.documentElement.classList.add('ab9-modal-open');$('[data-ab9-close]').focus();
    // Re-check availability from live Shopify data; cached inline data is initial display only.
    const seq=++loading;
    fetch(url('products/'+encodeURIComponent(handle)+'.js'),{credentials:'same-origin'}).then(r=>r.ok?r.json():null).then(p=>{if(p && seq===loading){cache.set(handle,p);if(!selected.some(Boolean))renderProduct(p);else{product=p;renderOptions();}}}).catch(()=>{});
  }
  $('[data-ab9-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
  $('[data-ab9-add]').addEventListener('click',async()=> {
    if(!findVariant()?.available)return;const add=$('[data-ab9-add]');add.disabled=true;setStatus('Adding to cart…');
    try {
      const response=await fetch(url('cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
      const result=await response.json();if(!response.ok)throw new Error(result.description || 'This size is unavailable. Choose another size.');
      setStatus('Added to cart.');
      const cart=await fetch(url('cart.js'),{credentials:'same-origin'}).then(r=>r.json());
      document.querySelectorAll('.cart-link__count').forEach(el=>{el.textContent=cart.item_count;});
      document.dispatchEvent(new CustomEvent('ab:cart:updated',{detail:cart}));
      if(window.jQuery)window.jQuery(document).trigger('cc-cart-refresh');
      setTimeout(close,650);
    } catch(e) {setStatus(e.message);}finally{updatePurchase();}
  });
  function saved() {try {const data=JSON.parse(localStorage.getItem('activeBasicsWishlist')||'[]');return Array.isArray(data)?data:[];}catch(e){return [];}}
  function within(scope, selector) { return [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)]; }
  function syncSaved(scope = document) {const items=saved();within(scope,'[data-ab9-wishlist]').forEach(button=>button.setAttribute('aria-pressed',items.includes(button.dataset.ab9Wishlist)?'true':'false'));}
  document.addEventListener('click',event=> {
    const button=event.target.closest('[data-ab9-open]');if(button){event.preventDefault();open(button).catch(e=>{window.location.href=url('products/'+button.dataset.ab9Open);});return;}
    const save=event.target.closest('[data-ab9-wishlist]');if(save){event.preventDefault();const items=saved(),handle=save.dataset.ab9Wishlist; const i=items.indexOf(handle);if(i<0)items.push(handle);else items.splice(i,1);try{localStorage.setItem('activeBasicsWishlist',JSON.stringify(items));}catch(e){}syncSaved();}
    const tab=event.target.closest('[data-ab-mobile-tab]');if(tab){const drawer=tab.closest('.mobile-navigation-drawer');if(!drawer)return;drawer.querySelectorAll('[data-ab-mobile-tab]').forEach(t=>{const active=t===tab;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',active?'true':'false');});drawer.querySelectorAll('[data-ab-mobile-panel]').forEach(p=>{const active=p.dataset.abMobilePanel===tab.dataset.abMobileTab;p.hidden=!active;p.classList.toggle('is-active',active);});}
  });
  function enhanceProductColours(scope = document) {
    within(scope,'[data-ab-v9-product]').forEach(root => {
      if(root.querySelector('.ab9-product-colour-family'))return;
      let p;try{p=JSON.parse(root.querySelector('script[id^="ProductJson-"]').textContent);}catch(e){return;}
      if(options(p).some(o=>/colou?r/i.test(o.name)))return;
      const group=map[p.handle];if(!group)return;
      const form=root.querySelector('form.product-purchase-form');if(!form)return;
      const selected=group.find(x=>x.handle===p.handle);
      const host=element('div',{className:'ab9-product-colour-family'});
      host.append(element('p',{},'Colour: '+(selected?.colour || '')));
      const links=element('div',{className:'ab9-card-swatches'});
      group.forEach(x=>{const a=element('a',{href:url('products/'+x.handle),title:x.colour});a.setAttribute('aria-label',x.colour);a.setAttribute('aria-current',x.handle===p.handle?'true':'false');a.style.background=x.hex;links.append(a);});host.append(links);form.prepend(host);
    });
  }
  function enhanceLooks(scope = document) {
    within(scope,'[data-ab-v9-look-row]').forEach(row => {
      const siblings=map[row.dataset.productHandle];
      if(!siblings || row.querySelector('[data-ab9-look-colour]'))return;
      const controls=row.querySelector('.ab-v9-look-row__controls');if(!controls)return;
      const label=element('label',{className:'ab-v9-look-option ab9-look-colour'});label.append(element('span',{},'Colour'));
      const select=element('select');select.dataset.ab9LookColour='true';select.setAttribute('aria-label','Choose colour');
      siblings.forEach(s=>{const o=element('option',{value:s.handle},s.colour);o.selected=s.handle===row.dataset.productHandle;select.append(o);});label.append(select);controls.prepend(label);
      select.addEventListener('change',async()=>{
        select.disabled=true;const status=row.querySelector('[data-ab-v9-look-status]');status.textContent='Loading colour…';
        try {
          const p=await loadProduct(select.value);const clone=row.cloneNode(true);clone.dataset.productHandle=p.handle;clone.dataset.productId=p.id;
          const image=clone.querySelector('.ab-v9-look-row__image img');if(image){image.src=images(p)[0];image.alt=p.title;}
          clone.querySelectorAll('.ab-v9-look-row__image,.ab-v9-look-row__title').forEach(a=>a.href=url('products/'+p.handle));
          clone.querySelector('.ab-v9-look-row__title').textContent=p.title;
          const first=p.variants.find(v=>v.available)||p.variants[0];
          clone.querySelector('[data-ab-v9-look-price]').textContent=money(first.price);
          clone.querySelector('[data-ab-v9-look-id]').value=first.id;
          const data=clone.querySelector('[data-ab-v9-look-data]');data.textContent=JSON.stringify(p.variants.map(v=>({...v,priceText:money(v.price)})));
          const opts=clone.querySelector('.ab-v9-look-row__controls');opts.querySelectorAll('.ab-v9-look-option').forEach(l=>l.remove());
          options(p).forEach((o,i)=>{
            if(o.name==='Title' && o.values.length===1 && o.values[0]==='Default Title')return;
            const l=element('label',{className:'ab-v9-look-option'});l.append(element('span',{},o.name));const s=element('select');s.dataset.abV9LookOption='';s.dataset.optionIndex=i;s.setAttribute('aria-label',o.name);
            o.values.forEach(v=>{const item=element('option',{value:v},v);item.selected=v===first.options[i];s.append(item);});l.append(s);opts.insertBefore(l,opts.querySelector('[data-ab-v9-look-add]'));
          });
          clone.querySelector('[data-ab-v9-look-status]').textContent='';row.replaceWith(clone);
          window.ABV9Product?.init(document);enhanceLooks();
        }catch(e){status.textContent=e.message;select.disabled=false;select.value=row.dataset.productHandle;}
      });
    });
  }
  // Card image delivery is independent of the asynchronous colour-map request.
  const mediaStates = new WeakMap();
  const watchedMedia = new Set();
  let initialCardPass = true;
  const mediaObserver = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(entries => entries.forEach(entry => {
      const state = mediaStates.get(entry.target);
      if (!state) return;
      state.near = entry.isIntersecting && getComputedStyle(entry.target).visibility !== 'hidden';
      if (state.near) warmCard(state);
      else { clearTimeout(state.warmTimer); state.warmTimer = null; }
    }), {rootMargin: '240px 0px'}) : null;
  const mediaResizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(entries => {
      // ResizeObserver supplies widths without interleaving layout reads and writes.
      entries.forEach(entry => setCardSizes(mediaStates.get(entry.target), entry.contentRect.width));
    }) : null;

  function setCardSizes(state, width) {
    if (!state || width <= 0) return;
    state.width = width;
    state.photos.forEach(image => {
      // The settled 4:5 frame uses object-fit:cover, including wider source photos.
      const sourceWidth = Number(image.getAttribute('width')), sourceHeight = Number(image.getAttribute('height'));
      const cover = sourceWidth > 0 && sourceHeight > 0 ? Math.max(1, (sourceWidth / sourceHeight) / (4 / 5)) : 1;
      const sizes = Math.ceil(width * cover) + 'px';
      if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
    });
  }
  function sourcePhoto(image, interactive = false) {
    if (!image) return;
    if (interactive) image.setAttribute('fetchpriority', 'auto');
    if (!image.hasAttribute('data-ab9-src')) return;
    image.loading = 'eager';
    const srcset = image.getAttribute('data-ab9-srcset');
    if (srcset) image.setAttribute('srcset', srcset);
    image.setAttribute('src', image.getAttribute('data-ab9-src'));
    image.removeAttribute('data-ab9-src');
    image.removeAttribute('data-ab9-srcset');
  }
  function warmCard(state) {
    if (!state.near || !state.media.isConnected || state.warmTimer || !state.photos[1]?.hasAttribute('data-ab9-src')) return;
    const primary = state.photos[0];
    // Never spend alternate-photo bandwidth before this card's primary is available.
    if (!primary?.complete || !primary.naturalWidth) return;
    state.warmTimer = setTimeout(() => {
      state.warmTimer = null;
      if (state.near && state.media.isConnected) sourcePhoto(state.photos[1]);
    }, 1600);
  }
  function initCardMedia(card, media) {
    let state = mediaStates.get(media);
    const photos = [...media.querySelectorAll('img')];
    if (state) {
      if (!watchedMedia.has(media)) { watchedMedia.add(media); mediaObserver?.observe(media); mediaResizeObserver?.observe(media); }
      if (photos.length !== state.photos.length || photos.some((photo, i) => photo !== state.photos[i])) {
        state.stop(); state.photos = photos; state.index = 0;
        photos[0]?.addEventListener('load', () => warmCard(state));
        if (photos.length && !photos.some(photo => photo.classList.contains('is-active'))) photos[0].classList.add('is-active');
        if (state.width) setCardSizes(state, state.width);
      }
      return state;
    }
    state = {media, photos, index: 0, timer: null, request: 0, near: false, warmTimer: null, width: 0};
    mediaStates.set(media, state); watchedMedia.add(media); media.dataset.ready = 'true';
    if (photos.length && !photos.some(photo => photo.classList.contains('is-active'))) photos[0].classList.add('is-active');
    const stop = () => { clearInterval(state.timer); state.timer = null; ++state.request; };
    state.stop = stop;
    async function show(next) {
      const image = state.photos[next]; if (!image) return;
      const request = ++state.request;
      sourcePhoto(image, true);
      // An already-loaded primary restores synchronously on mouse leave.
      if (!(next === 0 && image.complete && image.naturalWidth)) {
        try { await image.decode(); } catch(e) { return; }
      }
      if (request !== state.request || !media.isConnected) return;
      state.photos.forEach(photo => photo.classList.toggle('is-active', photo === image)); state.index = next;
    }
    const interact = () => state.photos.slice(1).forEach(photo => sourcePhoto(photo, true));
    card.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse' || state.photos.length < 2 || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      stop(); interact(); state.timer = setInterval(() => show((state.index + 1) % state.photos.length), 1400);
    });
    card.addEventListener('pointerleave', () => { stop(); show(0); });
    let start = null;
    media.addEventListener('touchstart', event => { start = event.touches[0].clientX; interact(); }, {passive:true});
    media.addEventListener('touchend', event => {
      if (start === null) return;
      const dx = event.changedTouches[0].clientX - start;
      if (Math.abs(dx) > 35 && state.photos.length) {
        show((state.index + (dx < 0 ? 1 : state.photos.length - 1)) % state.photos.length);
        const link = media.closest('a');
        const cancel = event => { event.preventDefault(); link.removeEventListener('click', cancel); };
        link.addEventListener('click', cancel, {once:true}); setTimeout(() => link.removeEventListener('click', cancel), 400);
      }
      start = null;
    }, {passive:true});
    photos[0]?.addEventListener('load', () => warmCard(state));
    mediaObserver?.observe(media); mediaResizeObserver?.observe(media);
    return state;
  }
  function prepareCardImages(cards, initial) {
    // Read all changed-card geometry first, then apply attributes. No loop-index assumptions.
    const measured = cards.map(card => {
      const media = card.querySelector('[data-ab9-cycle]');
      return media ? {card, media, rect: media.getBoundingClientRect(), hidden: initial && getComputedStyle(media).visibility === 'hidden'} : null;
    }).filter(Boolean);
    let eager = 4, high = 2;
    const viewportHeight = window.innerHeight, viewportWidth = window.innerWidth;
    measured.forEach(({card, media, rect, hidden}) => {
      const state = initCardMedia(card, media); setCardSizes(state, rect.width);
      const primary = state.photos[0];
      const visible = !hidden && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < viewportHeight && rect.right > 0 && rect.left < viewportWidth;
      if (initial && visible && primary && eager-- > 0) {
        primary.loading = 'eager';
        if (high-- > 0) primary.setAttribute('fetchpriority', 'high');
      }
    });
  }

  // Product-card colour rows only: full product and Quick Add palettes stay intact.
  const swatchStates = new WeakMap();
  const watchedSwatches = new Set();
  const pendingSwatches = new Set();
  let swatchFrame = null;
  const swatchObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(entries => entries.forEach(entry => queueSwatches(entry.target))) : null;
  function queueSwatches(host) {
    if (!swatchStates.has(host)) return;
    pendingSwatches.add(host);
    if (swatchFrame !== null) return;
    swatchFrame = requestAnimationFrame(() => {
      swatchFrame = null;
      // Read every affected row before writing any hidden/link/style state.
      const measurements = [...pendingSwatches].filter(host => host.isConnected).map(host => readSwatches(host, swatchStates.get(host))).filter(Boolean);
      pendingSwatches.clear(); measurements.forEach(applySwatches);
    });
  }
  function readSwatches(host, state) {
    const links = Array.from(host.children).filter(el => el.tagName === 'A' && !el.classList.contains('ab9-swatch-more'));
    if (!links.length) return;
    const style = getComputedStyle(host);
    const number = value => parseFloat(value) || 0;
    const width = host.getBoundingClientRect().width
      - number(style.paddingLeft) - number(style.paddingRight)
      - number(style.borderLeftWidth) - number(style.borderRightWidth);
    if (width <= 0) return;
    const sample = links.find(link => !link.hidden) || links[0];
    const dotStyle = getComputedStyle(sample), dot = sample.getBoundingClientRect();
    const itemWidth = dot.width || number(dotStyle.width), itemHeight = dot.height || number(dotStyle.height);
    if (!itemWidth || !itemHeight) return;
    const columnGap = number(style.columnGap);
    const capacity = Math.max(1, Math.floor((width + columnGap + 0.05) / (itemWidth + columnGap)));
    const overflowing = links.length > capacity, visibleCount = overflowing ? capacity - 1 : links.length;
    const keep = new Set(links.slice(0, visibleCount));
    const selected = links.find(link => link.getAttribute('aria-current') === 'true');
    if (selected && !keep.has(selected) && visibleCount > 0) { keep.delete(links[visibleCount - 1]); keep.add(selected); }
    return {host, state, links, itemWidth, itemHeight, overflowing, keep};
  }
  function applySwatches({host, state, links, itemWidth, itemHeight, overflowing, keep}) {
    links.forEach(link => { const hidden = !keep.has(link); if (link.hidden !== hidden) link.hidden = hidden; });
    host.style.setProperty('--ab9-swatch-more-size', itemWidth + 'px');
    host.style.removeProperty('--ab9-swatch-two-rows');
    host.style.setProperty('--ab9-swatch-row-height', itemHeight + 'px');
    host.classList.add('ab9-swatches-limited');
    if (overflowing) {
      if (!state.more) {
        const data = cardData(state.card), productLink = state.card.querySelector('a[href*="/products/"]');
        const href = data?.handle ? url('products/' + data.handle) : productLink?.href;
        if (!href) return;
        state.more = element('a', {className: 'ab9-swatch-more', href, title: 'View all colours'}, '+'); host.append(state.more);
      }
      state.more.setAttribute('aria-label', 'View all ' + links.length + ' colours'); state.more.hidden = false;
    } else if (state.more) state.more.hidden = true;
  }
  function capCardSwatches(host, card) {
    if (!swatchStates.has(host)) {
      swatchStates.set(host, {card, more: host.querySelector('.ab9-swatch-more')});
    }
    if (!watchedSwatches.has(host)) {
      watchedSwatches.add(host); swatchObserver?.observe(host);
    }
    queueSwatches(host);
  }
  function cleanupCards() {
    watchedSwatches.forEach(host => {
      if (!host.isConnected) { swatchObserver?.unobserve(host); watchedSwatches.delete(host); pendingSwatches.delete(host); }
    });
    watchedMedia.forEach(media => {
      if (!media.isConnected) {
        const state = mediaStates.get(media); state.stop(); clearTimeout(state.warmTimer); state.warmTimer = null;
        mediaObserver?.unobserve(media); mediaResizeObserver?.unobserve(media); watchedMedia.delete(media);
      }
    });
  }
  window.addEventListener('resize', () => {
    watchedSwatches.forEach(queueSwatches);
    if (!mediaResizeObserver) {
      const measured = [...watchedMedia].filter(media => media.isConnected).map(media => [mediaStates.get(media), media.getBoundingClientRect().width]);
      measured.forEach(([state, width]) => setCardSizes(state, width));
    }
  }, {passive:true});
  function enhanceCards(scope = document) {
    const cards = within(scope, '.ab9-product-card');
    prepareCardImages(cards, initialCardPass); initialCardPass = false;
    cards.forEach(card => {
      const p = cardData(card); if (!p) return; const group = map[p.handle];
      if (group && !card.querySelector('.ab9-card-swatches')) {
        const title = card.querySelector('.product-block__title'); if (title) title.textContent = group[0].style;
        const host = card.querySelector('.product-info .innerer');
        if (host) {
          const swatches = element('div', {className:'ab9-card-swatches'}); swatches.setAttribute('aria-label','Available colours');
          group.forEach(x => { const a = element('a', {href:url('products/'+x.handle),title:x.colour}); a.setAttribute('aria-label',x.colour); a.setAttribute('aria-current',x.handle===p.handle?'true':'false'); a.style.background=x.hex; swatches.append(a); }); host.append(swatches);
        }
      }
      const cardSwatches = card.querySelector('.ab9-card-swatches'); if (cardSwatches) capCardSwatches(cardSwatches, card);
    });
    syncSaved(scope); enhanceLooks(scope); enhanceProductColours(scope);
  }
  enhanceCards();
  const changedScopes = new Set();
  let pending = null;
  function queueScope(scope) {
    if (!scope?.querySelectorAll) return;
    for (const existing of changedScopes) { if (existing.contains(scope)) return; if (scope.contains(existing)) changedScopes.delete(existing); }
    changedScopes.add(scope);
    if (pending !== null) return;
    pending = setTimeout(() => {
      pending = null; const scopes = [...changedScopes]; changedScopes.clear();
      scopes.forEach(scope => { if (scope.isConnected) enhanceCards(scope); }); cleanupCards();
    }, 80);
  }
  const enhancementSelector = '.ab9-product-card,[data-ab-v9-product],[data-ab-v9-look-row]';
  new MutationObserver(records => {
    let removed = false;
    records.forEach(record => {
      const removedElements = [...record.removedNodes].filter(node => node.nodeType === 1);
      if (removedElements.length) removed = true;
      // Our palette/title writes and source-attribute updates cannot trigger card rescans.
      if (record.target.closest?.('.ab9-card-swatches,.ab9-product-colour-family,.ab9-look-colour')) return;
      if (removedElements.some(node => !node.matches('.ab9-card-swatches,.ab9-product-colour-family,.ab9-look-colour'))) {
        const card = record.target.closest?.('.ab9-product-card'); if (card) queueScope(card);
      }
      const added = [...record.addedNodes].filter(node => node.nodeType === 1 && !node.matches('.ab9-card-swatches,.ab9-product-colour-family,.ab9-look-colour'));
      added.forEach(node => {
        if (node.matches(enhancementSelector) || node.querySelector(enhancementSelector)) queueScope(node);
        else { const owner = record.target.closest?.(enhancementSelector); if (owner) queueScope(owner); }
      });
    });
    if (removed) cleanupCards();
  // Include header live-search insertions; the callback still enhances only changed card scopes.
  }).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', event => queueScope(event.target));
})();
